import * as React from 'react';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { AppUser } from 'Src/views/App/App';
import { Component } from 'react';
import { History, Location } from 'history';
import { Loader } from 'Src/components/Loader/Loader';
import { EventInvitationMessage } from 'Src/models/message';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { getStudentArchiveMessages, getStudentArchiveMessagesCount } from 'Src/helpers/service/student/messagesTable';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { CARD_LIMIT } from 'Src/consts/table';
import { AvailabilityReportCard } from 'Src/components/AvailabilityReportCard/AvailabilityReportCard';
import { ParentAvailabilityOverview } from 'Src/components/ParentAvailabilityOverview/ParentAvailabilityOverview';
import { INVITE_TYPE } from 'Src/consts/invite';
import { Map } from 'Src/components/Map/Map';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { AvailabilityReportsDetails } from '../AvailabilityReportsDetails/AvailabilityReportsDetails';
import { getStudentEvent } from 'Src/helpers/service/student/events';
import { SchoolEvent } from 'Src/models/event';
import { currentAcademicYearRange } from 'Src/helpers/club/clubSectionCounts';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  mode?: 'current' | 'previous';
}

const availabilityArchiveRange = (mode?: 'current' | 'previous') => {
  const current = currentAcademicYearRange();
  if (mode !== 'previous') return current;
  const end = new Date(`${current.from}T00:00:00Z`);
  end.setUTCDate(end.getUTCDate() - 1);
  return { to: end.toISOString().slice(0, 10) };
};

interface State {
  items: EventInvitationMessage[];
  selectedItem: EventInvitationMessage;
  event: SchoolEvent;
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  basePath: string;
  isViewMapModalOpen: boolean;
  isShowDetailsModalOpen: boolean;
}

const FILTER_FIELDS: ColumnDefinition[] = [
  {
    text: 'Sport',
    field: 'sport',
    type: FILTER_TYPE.TEXT,
    accessor: [''],
    isSort: false
  },
  {
    text: 'Start date',
    field: 'startTime',
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: [''],
    isSort: true
  },
  {
    text: 'Finish date',
    field: 'finishTime',
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: [''],
    isSort: false
  },
  {
    text: 'Deadline',
    field: 'deadlineForAnswers',
    type: FILTER_TYPE.NONE,
    accessor: [''],
    isSort: true
  }
];

export class AvailabilityReportsArchive extends Component<Props, State> {
  private loadRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      selectedItem: undefined,
      event: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      basePath: '',
      isViewMapModalOpen: false,
      isShowDetailsModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search || nextProps.mode !== this.props.mode) {
      this.setState({
        isLoading: true
      });
      this.setItems(nextProps);
    }
  }

  setItems(props: Props = this.props) {
    const requestId = ++this.loadRequestId;
    const { user, location } = props;

    const search = parse(location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortFieldName = '';

    if (typeof search.order === 'string') {
      [sortFieldName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortFieldName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(FILTER_FIELDS, search);
    const hasAppliedArchiveFilters = Object.keys(search).some(key => key !== 'page' && key !== 'order');
    if (!filters.startTime && props.mode !== 'previous') {
      filters.startTime = availabilityArchiveRange(props.mode);
    }

    if (props.mode === 'previous' && !hasAppliedArchiveFilters) {
      this.setState({
        items: [],
        currentPage: FIRST_PAGE,
        filters,
        sortDirection,
        sortFieldName,
        total: 0,
        basePath: location.pathname,
        isLoading: false
      });
      return BPromise.resolve();
    }

    const where = {
      kind: 'EventParticipationMessage',
      ...getServerFieldSectionWhere(filters)
    };

    const order = sortByFieldExist && sortDirectionExist ? `${sortFieldName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);

    const getItemsPromise = getStudentArchiveMessages(user, serverQueryFilter);
    const getItemsCountPromise = getStudentArchiveMessagesCount(user, where);

    const promises = [getItemsPromise, getItemsCountPromise];

    return BPromise.all(promises).then(([clubBookings, clubBookingsCountObj]) => {
      if (requestId !== this.loadRequestId) return;
      this.setState({
        items: clubBookings,
        currentPage: page,
        filters,
        sortDirection,
        sortFieldName,
        total: clubBookingsCountObj.count,
        basePath: location.pathname,
        isLoading: false
      });
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    const { history } = this.props;
    let search: string[] = [];

    const { filters, sortFieldName, sortDirection, basePath } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortFieldName)) {
      search.push(getSearchOrder(sortDirection, sortFieldName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortFieldName, filters, basePath } = this.state;

    const order = getOrder(sortField, sortDirection, sortFieldName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = FILTER_FIELDS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortFieldName, basePath } = this.state;
    const { history } = this.props;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) {
      search.push(getSearchOrder(sortDirection, sortFieldName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    const { basePath } = this.state;

    this.props.history.push({
      pathname: basePath,
      search: ''
    });
  };

  renderViewMapModal = () => {
    const { isViewMapModalOpen, event } = this.state;

    const point =
      propz.get(event, ['venue', 'postcodeData', 'point']) ||
      propz.get(event, ['venue', 'placeData', 'point']) ||
      propz.get(event, ['venue', 'point']) ||
      undefined;

    return (
      <SimpleModal
        isOpen={isViewMapModalOpen}
        onCloseClick={this.closeViewMapModal}
        title="View map"
        customClass="parentCompactModal"
      >
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };

  openViewMapModal = (item: EventInvitationMessage) => {
    const { user } = this.props;
    const eventId = String(propz.get(item, ['eventData', 'id'], ''));
    this.setState({ isLoading: true });

    getStudentEvent(user, eventId)
      .then(event => this.setState({ isViewMapModalOpen: true, selectedItem: item, event, isLoading: false }))
      .catch(() => this.setState({ isViewMapModalOpen: true, selectedItem: item, event: undefined, isLoading: false }));
  };

  closeViewMapModal = () => {
    this.setState({
      isViewMapModalOpen: false,
      selectedItem: undefined
    });
  };

  renderShowDetailsModal = () => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { isShowDetailsModalOpen, selectedItem, event } = this.state;

    return (
      <SimpleModal
        isOpen={isShowDetailsModalOpen}
        onCloseClick={this.closeShowDetailsModal}
        title="Availability report details"
        side="right"
        customClass="parentCompactModal"
        buttonCancelText="Close"
      >
        <AvailabilityReportsDetails item={selectedItem} event={event} activeSchoolId={activeSchoolId} />
      </SimpleModal>
    );
  };

  openShowDetailsModal = item => {
    const { user } = this.props;
    const eventId = propz.get(item, ['eventData', 'id'], '');

    this.setState({
      isLoading: true
    });

    getStudentEvent(user, eventId).then(event => {
      this.setState({
        isShowDetailsModalOpen: true,
        selectedItem: item,
        event,
        isLoading: false
      });
    });
  };

  closeShowDetailsModal = () => {
    this.setState({
      isShowDetailsModalOpen: false,
      selectedItem: undefined
    });
  };

  render() {
    const { isLoading, isFiltersOpen, total, currentPage, items, filters } = this.state;
    const archiveSearch = parse(this.props.location.search);
    const hasAppliedArchiveFilters = Object.keys(archiveSearch).some(key => key !== 'page' && key !== 'order');

    const needsDateHint =
      !!(filters?.sport && String(filters.sport).trim()) &&
      !(
        propz.get(filters, ['startTime', 'from']) ||
        propz.get(filters, ['startTime', 'to']) ||
        propz.get(filters, ['finishTime', 'from']) ||
        propz.get(filters, ['finishTime', 'to'])
      );

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="studentAvailabilityContent">
        {this.renderViewMapModal()}
        {this.renderShowDetailsModal()}
        <div className="studentHubControls">
          <div className="parentListSearch">
            <input
              type="search"
              className="form-control"
              placeholder="Search sport…"
              value={filters.sport || ''}
              onChange={e => this.onTableFilterChange(e, 'sport')}
              onKeyDown={e => {
                if (e.key === 'Enter') this.onApplyFilterClick();
              }}
            />
          </div>
          <button
            type="button"
            className={isFiltersOpen ? 'parentFilterButton is-active' : 'parentFilterButton'}
            onClick={() => this.setState(prev => ({ isFiltersOpen: !prev.isFiltersOpen }))}
          >
            <span className="parentFilterButton__icon" aria-hidden="true" /> Filters
          </button>
          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div>

        <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'sport', label: 'Sport' },
            { filterKey: 'startTime', label: 'Start date', type: 'date' },
            { filterKey: 'finishTime', label: 'Finish date', type: 'date' }
          ]}
        />

        {isFiltersOpen && (
          <ParentFilterBar
            filters={filters}
            showTextFilter={false}
            onTableFilterChange={this.onTableFilterChange}
            onApply={this.onApplyFilterClick}
            onClear={this.onClearFilterClick}
            onCancel={() => this.setState({ isFiltersOpen: false })}
            hint={
              needsDateHint ? <>Choose a start or finish date as well as a sport to search the archive.</> : undefined
            }
            labels={{ text: 'Sport', date: 'Start date', secondDate: 'Finish date' }}
            fieldKeys={{ textKey: 'sport', dateKey: 'startTime', secondDateKey: 'finishTime' }}
          />
        )}

        {items.length === 0 ? (
          <div className="studentHubEmpty">
            <span className="studentHubEmpty__icon">A</span>
            <strong>
              {this.props.mode === 'previous' && !hasAppliedArchiveFilters
                ? 'Search previous academic years'
                : this.props.mode === 'previous'
                ? 'No availability reports match your filters'
                : 'No availability reports from this academic year'}
            </strong>
            <p>
              {this.props.mode === 'previous' && !hasAppliedArchiveFilters
                ? 'Use the event date and other filters to find an older availability report.'
                : this.props.mode === 'previous'
                ? 'Try changing the event date range or removing one of the other filters.'
                : 'Submitted reports from this academic year will appear here.'}
            </p>
          </div>
        ) : <ParentAvailabilityOverview items={items} user={this.props.user} readOnly onView={this.openShowDetailsModal} />}
      </div>
    );
  }
}
